module.exports = __webpack_public_path__ + "img/welcome@2x.8816be8f.png";